module.exports = __webpack_public_path__ + "img/20minutos.6f68ae90.jpg";